module.exports = __webpack_public_path__ + "img/advantages-bg--375.06f4929.webp";